import { render } from "./PromptsView.vue?vue&type=template&id=7ca7bd78&scoped=true"
import script from "./PromptsView.vue?vue&type=script&lang=js"
export * from "./PromptsView.vue?vue&type=script&lang=js"

import "./PromptsView.vue?vue&type=style&index=0&id=7ca7bd78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca7bd78"]])

export default __exports__